import { useMutation } from '@apollo/client';
import { ListDependentsDocument, } from '../generated/graphql-types';
export const useListDependentsMutation = () => {
    const [__useListDependents, { data, error, loading }] = useMutation(ListDependentsDocument);
    return {
        data,
        error,
        loading,
        useListDependents: (ids, type) => __useListDependents({
            variables: {
                ids,
                type,
            },
        }),
    };
};
//# sourceMappingURL=listdependents-service.js.map